import script from "./HonorBook.vue?vue&type=script&setup=true&name=HonorBook&lang=js"
export * from "./HonorBook.vue?vue&type=script&setup=true&name=HonorBook&lang=js"

import "./HonorBook.vue?vue&type=style&index=0&id=1b8b0f3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8b0f3b"]])

export default __exports__